module.exports = __webpack_public_path__ + "img/report_img_202110.f376579d.jpg";